import { Component, ChangeDetectionStrategy, Input, HostBinding, OnInit, OnChanges } from '@angular/core';
import { IAlert } from './alert.interface';
import { environment } from 'src/environments/environment';
import { NamespaceType } from '@common/namespace-types.type';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnInit, OnChanges {
  @Input() alertMessage!: IAlert | null;

  @HostBinding('style.background') background!: string;
  @HostBinding('style.color') color!: string;
  @HostBinding('style.display') display!: string;

  ngOnInit(): void {}

  ngOnChanges() {
    if (environment.namespace === NamespaceType.RSHB) {
      this.background = '#38424F';
    } else {
      switch (this.alertMessage?.type) {
        case 'ERROR':
          this.background = '#FDEBEB';
          break;
        case 'ALERT':
          this.background = '#FFF4DC';
          break;

        default:
          this.background = '#E0E0E0';
          break;
      }
    }
  }

  close(): void {
    this.display = 'none';
  }
}
